"use strict";

var REGEX_URL = new RegExp(/(((http|https):\/{2})?(www.)?([a-z0-9-]+\.){1,2})([a-z]{2,3}(\/([\w\?\=\&\%\@\.\-\_\!\#]*\/*)*\b|\b))/g);

module.exports.replaceURLsInText = function replaceURLsInText(text, newValue) {
  if (newValue) {
    return text.replace(REGEX_URL, newValue);
  } else {
    throw new Error("The param newValue is not defined.");
  }
};

module.exports.findURLsInText = function findURLsInText(text) {
  return text.match(REGEX_URL);
};

module.exports.applyScheme = function applyScheme(url) {
  var urlWithScheme = url;

  var containSheme = url.indexOf("http") !== -1;
  if (!containSheme) {
    urlWithScheme = "http://".concat(url);
  }

  return urlWithScheme;
};

module.exports.linkify = function linkify(str) {
  // http://, https://, ftp://
  var urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;

  // www. sans http:// or https://
  var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

  // Email addresses
  var emailAddressPattern = /[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim;

  return str
    .replace(urlPattern, "<a target='_blank' href='$&'>$&</a>")
    .replace(pseudoUrlPattern, "$1<a target='_blank' href='http://$2'>$2</a>")
    .replace(emailAddressPattern, "<a href='mailto:$&'>$&</a>");
};



// WEBPACK FOOTER //
// ./app/util/formatter/url.js